import { Grid, GridCellProps, GridColumn } from '@progress/kendo-react-grid';
import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { selectCustomers } from '../../features';
import { ILocation } from '../../model';
import { locationService } from '../../services';
import { useAppSelector } from '../../store/hooks';

import styles from './Locations.module.scss';

interface ILocationsState {
  data: ILocation[];
  total: number;
}

const LocationNameCell: FC<GridCellProps> = ({ dataItem, className, style }) => (
  <td className={className} style={style}>
    <Link className={styles.nameLink} to={`/locations/${dataItem.id}`}>
      {dataItem.name}
    </Link>
  </td>
);

const Locations: FC = () => {
  const customers = useAppSelector(selectCustomers);

const [locationsState, setLocationsState] = useState<ILocationsState>({
    data: [],
    total: 0,
  });

  useEffect(() => {
    if (customers.current) {
      locationService.getLocations().then((response) => {
        setLocationsState({
          data: response,
          total: response.length,
        });
      });
    } else {
      setLocationsState({
        data: [],
        total: 0,
      });
    }
  }, [customers, customers.current?.id]);

  return (
    <div className={styles.locationsPage}>
      <Grid
        data={locationsState.data}
        total={locationsState.total}
        style={{ padding: '20px' }}
        className={`${styles.locationsGrid} grid-auto-scroll`}
      >
        <GridColumn field='id' title='ID' />
        <GridColumn field='name' title='Location Name' cell={LocationNameCell} />
      </Grid>
    </div>
  );
};

export default Locations;
